/*rutas de Banking*/
export default [
    {
      path: '/Display/setting',
      name: 'DisplaySetting',
      view: 'DisplaySetting',
      folder: 'views/Display',
      meta: {requiresAuth: true}
    },
];